/**
 * Currency formatting utilities for form inputs
 */

/**
 * Format user input as currency in real-time
 * Example: "1234.56" → "$1,234.56"
 */
export const formatCurrencyInput = (value: string): string => {
  if (!value) return '';
  
  // Remove all non-numeric characters except decimal point
  const cleaned = value.replace(/[^0-9.]/g, '');
  
  if (!cleaned) return '';
  
  // Handle multiple decimal points (keep only the first)
  const parts = cleaned.split('.');
  const integerPart = parts[0] || '0';
  const decimalPart = parts.length > 1 ? parts[1].substring(0, 2) : '';
  
  // Add thousand separators
  const formatted = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Construct final value
  if (decimalPart !== undefined && parts.length > 1) {
    return `$${formatted}.${decimalPart}`;
  }
  
  return `$${formatted}`;
};

/**
 * Parse formatted currency to clean numeric string for storage
 * Example: "$1,234.56" → "1234.56"
 */
export const parseCurrencyInput = (value: string): string => {
  if (!value) return '';
  const cleaned = value.replace(/[^0-9.]/g, '');
  return cleaned;
};

/**
 * Format numeric value for display
 * Example: 1234.56 → "$1,234.56"
 */
export const formatCurrencyDisplay = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};
